exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RoomsBeds-roomsBedGap-eZluh {\n    gap: 11px;\n}\n\n.RoomsBeds-bedIcon-uKHXi {\n    width: 100%;\n    max-width: 22px;\n    min-width: 22px;\n}\n\n.RoomsBeds-bedsWidth-6W9cz {\n    width: 70%;\n}\n\n@media screen and (max-width: 767px) {\n    .RoomsBeds-roomsBedGapSection-k-sua {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n        gap: 10px;\n    }\n\n    .RoomsBeds-bedsWidth-6W9cz {\n        width: 100%;\n    }\n}\n\n.RoomsBeds-secondFontColor-dtR8G{\n    color: var(--second-font-color);\n}\n\n.RoomsBeds-bathIconBg-Ps20p {\n    background-color: var(--icon-bg-color);\n    border-radius: 50%;\n    padding: 5px;\n}", ""]);

// exports
exports.locals = {
	"roomsBedGap": "RoomsBeds-roomsBedGap-eZluh",
	"bedIcon": "RoomsBeds-bedIcon-uKHXi",
	"bedsWidth": "RoomsBeds-bedsWidth-6W9cz",
	"roomsBedGapSection": "RoomsBeds-roomsBedGapSection-k-sua",
	"secondFontColor": "RoomsBeds-secondFontColor-dtR8G",
	"bathIconBg": "RoomsBeds-bathIconBg-Ps20p"
};